import clsx from "clsx";
import { Step as StepProps } from "./index.types";
import { Badge } from "../badge";
import "./index.css";

export function Step({ className, num, title, status, children }: StepProps) {
  return (
    <div className={clsx("step", className)}>
      <div className="step__num">{num}</div>
      <div className="step__body">
        <h3>
          {title}{" "}
          {status && (
            <Badge
              size="sm"
              tone={status.variant === "now" ? "success" : "muted"}
            >
              {status.label}
            </Badge>
          )}
        </h3>
        <p>{children}</p>
      </div>
    </div>
  );
}

export default Step;
